// extracted by mini-css-extract-plugin
module.exports = {"block":"QuickLinks_block__70E9I","title":"QuickLinks_title__vgnk1","row":"QuickLinks_row__Cwsmp","link":"QuickLinks_link__8xW0V"};